import React, { useCallback } from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr } from '@utils/util';
import GridSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonGridSettings';
import { SimpleForm as Form, Collapse, Input, Select, Switch, Radio } from '@whalecloud/fdx';
import { getLocale } from '@utils/util';
import StepsSettingsTable from './StepsSettingsTable';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = "data.formItemSettings";
const formKey = "data.formSettings";

const StepsSetting = (props) => {
  const messages = getLocale();
  
  const { updateElement, element } = props;
  const { formItemSettings = {}, formSettings = {}, settings = {} } = element.data;
  const { steps, defaultActiveKey, ...resetProps } = formItemSettings;
  const { visible = true } = settings;

  const initialValues = {
    size: 'default',
    tabPosition: 'top',
    type: 'line',
    defaultActiveKey: defaultActiveKey,
    visible,
    ...formSettings,
    ...resetProps
  }

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let value = obj[key];
      if (['name', 'label'].includes(key)) {
        propName = `${formKey}.${key}`;
      }
      if (key === 'visible') {
        propName = `data.settings.${key}`
        value = obj[key] ? 'visible' : 'hidden';
      }
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement
      });
    })
  }

  const renderOption = useCallback(
    () => steps.map((item, index) => (<Option key={`tab_key_${index}`} value={index}>{item.title}</Option>)),
    [steps]
  )

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_NAME']} name="name">
            <Input placeholder="Input the form field name" />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_LABEL_TEXT']} name="label">
            <Input placeholder="Input the form field label" />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_VISIBLE']} name="visible" valuePropName="checked">
            <Switch />
          </Form.Item>
          <GridSettings />
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_SIZE']} name="size">
            <Radio.Group size="small">
              <Radio.Button value="small">{messages['PAGEBUIDER_SETTINGS_SMALL']}</Radio.Button>
              <Radio.Button value="default">{messages['PAGEBUIDER_SETTINGS_DEFAULT']}</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TAB_DEFAULT_KEY']} name="defaultActiveKey">
            <Select>
              {renderOption()}
            </Select>
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_TAB_POSITION']} key="2">
        <StepsSettingsTable element={element} updateElement={updateElement} />
      </Panel>
    </Collapse>
  );
};

export default StepsSetting;

